export default __webpack_public_path__ + "static/media/bg.8fc50ba2.jpg";